'use strict';

function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
    $scope.global = Global;

    let model = this;
    model.settings = settings;
    model.lineChartIdentifiers = {
        key: false,
        id: false
    };
    model.tableIdentifiers = {
        key: false,
        id: false
    };
    model.complete = false;

    socketIo('/api/stealth/stealth_conn_config').then(function(socket) {
        /////////////
        /// TABLE ///
        /////////////

        // register data object
        $scope.main.registerVisual({
                // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
                refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
                searchable: true, // optional search param.. no if undefined
                get: {
                    call: 'table',
                    socket: socket
                },
                grouping: ['resp_ip'],
                sort: {
                    direction: '-', // '-' == desc, '+' == asc
                    col: 'time'
                },
                title: 'Stealth Origin User Connections',
                columns: [{
                    title: 'Last Seen',
                    select: 'time',
                    dView: true,
                    link: {
                        type: 'search',
                        val: ['resp_ip', 'orig_ip'],
                        crumb: false
                    },
                }, {
                    title: 'Sensor',
                    select: 'sensor',
                    dView: true
                }, {
                    title: 'Responder IP',
                    select: 'resp_ip',
                    dView: true
                }, {
                    title: 'Responder Hostname',
                    select: 'resp_hostname',
                    dView: true
                }, {
                    title: 'Responder User',
                    select: 'resp_user',
                    dView: true
                }, {
                    title: 'Responder Stealth',
                    select: 'resp_stealth',
                    dView: true
                }, {
                    title: 'Origin IP',
                    select: 'orig_ip',
                    dView: true
                }, {
                    title: 'Origin Hostname',
                    select: 'orig_hostname',
                    dView: true
                }, {
                    title: 'Origin User',
                    select: 'orig_user',
                    dView: true
                }, {
                    title: 'Origin Stealth',
                    select: 'orig_stealth',
                    dView: true
                }, {
                    title: 'Payload Ratio',
                    select: 'breakdown',
                    dView: true
                }, {
                    title: 'Origin Payload',
                    select: 'bytes_orig',
                    dView: true
                }, {
                    title: 'Responder Payload',
                    select: 'bytes_resp',
                    dView: true
                }, ],
                searchCategories: {
                    'sensor': 'Sensor',
                    'resp_ip': 'Responder IP',
                    'resp_hostname': 'Responder Hostname',
                    'resp_user': 'Responder User',
                    'resp_stealth': 'Responder Stealth',
                    'orig_ip': 'Origin IP',
                    'orig_hostname': 'Origin Hostname',
                    'orig_user': 'Origin User',
                    'orig_stealth': 'Origin Stealth',
                }
            })
            // fetch the data when the object is registered
            .then(function(result) {
                model.tableIdentifiers = {
                        id: result.id,
                        key: result.key
                    }
                    // initalize table with column information so it can compile the directive
                $scope.$broadcast('table-build', model.tableIdentifiers);

                let time = angular.copy($scope.main.getTime());
                model.loadStart = time.end
                model.loadEnd = time.end
                    // return promise to build dimensions and groups for table
                return new fetchStream(result.settings.get.call, result.settings.get.socket);
            })
            .then(function(result) {
                model.complete = true;
                // stop the table spinner as soon as the resolve comes in
                usSpinnerService.stop(model.tableIdentifiers.id);
            }, function(err) {

            }, function(result) {
                // add rows
                $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
                if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                    // with our first data return, we can build dimensions and groups for our data
                    $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function() {
                        // dont start the spinner if the table loads faster than building group dim
                        if (!model.complete) {
                            // start table spinner right before init, but after build
                            usSpinnerService.spin(model.tableIdentifiers.id);
                        }
                        // initalize rows
                        $scope.$broadcast('init', model.tableIdentifiers);
                        if (result.min) {
                            model.loadStart = result.min;
                        }
                    }, function(err) {
                        console.log('error')
                        console.log(err)
                    })
                } else {
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                    $scope.$broadcast('updatedData', model.tableIdentifiers.id);
                }
            })
        $scope.$on('$destroy', function() {
            socket.disconnect();
        });
    })
};

ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/stealth/stealth_conn_orig.js
 **/